<template>
  <div class="block block-cust">
    <div class="container">
      <!--  -->
      <div class="card">
        <div class="wrap-logo">
          <img :src="logo" alt="" />
        </div>
        <div class="about-text">
          吉智合同系吉冉软件孵化的独立品牌产品，致力于帮助企业实现合同生命周期的极致管控、提高合同管理效率、降低风险、穿透合同业财数据。
          吉冉建有独立发合同产品研发，交付与运营团队，实现产品的可持续发展。
        </div>
        <div class="about-title">公司介绍</div>
        <div class="about-text">
          吉冉软件2014年成立，本部在南京、上海、苏州、杭州等地设有本土化交付与持续服务团队。与ULTIMUS合作成立ULTIMUS
          （VALUE-ADDED）CENTER，ULTIMUS中国增值应用研发中心。
        </div>

        <div class="row row-cust">
          <div class="col-xs-6 col-sm-3" v-for="item in rows" :key="item.key">
            <div class="item">
              <img :src="item.img" class="hvr-bounce-in" alt="" />
              <div class="item-text">
                {{ item.text }}
              </div>
              <div class="item-text2">
                {{ item.text2 }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/images/logo2.png";
import p1 from "@/assets/images/about/p1.png";
import p2 from "@/assets/images/about/p2.png";
import p3 from "@/assets/images/about/p3.png";
import p4 from "@/assets/images/about/p4.png";

const rows = [
  { key: 1, img: p1, text: "36项", text2: "自主知识产权" },
  { key: 2, img: p2, text: "7套", text2: "标准化产品" },
  { key: 3, img: p3, text: "50+", text2: "大中型上市企业客户" },
  { key: 4, img: p4, text: "15种", text2: "系统集成方案" },
];

export default {
  data() {
    return {
      logo,
      rows,
    };
  },
};
</script>

<style scoped>
.block-cust {
  background-color: #f6f8fc;
  padding-top: 100px;
}
.card {
  padding: 80px 40px;
  background: #fff;
  box-shadow: 4px 6px 25px 8px rgba(0, 0, 0, 0.03);
  position: relative;
}
.about-title {
  font-size: 26px;
  color: #2f56ce;
  margin-bottom: 20px;
}
.about-text {
  font-size: 18px;
  margin-bottom: 20px;
}
.row-cust {
  margin: 60px 0;
}
.item {
  text-align: center;
  margin-bottom: 20px;
}
.item-text {
  color: #f6c946;
  font-size: 32px;
  margin: 10px 0;
}
.item-text2 {
  color: #2f56ce;
  font-size: 26px;
}

.wrap-logo {
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  border: 1px solid #eee;
  position: absolute;
  z-index: 99;
  border-radius: 50%;
  background-color: #fff;
  left: 50%;
  top: -60px;
  margin-left: -60px;
}
.wrap-logo img {
  width: 60%;
}

/*  */
.mb .about-text {
  font-size: 14px;
}
.mb .item-text {
  font-size: 20px;
}
.mb .item-text2 {
  font-size: 12px;
}

.mb .item img {
  width: 80px;
}
</style>